// extracted by mini-css-extract-plugin
export default {"hideOptionsOnMobile":"hideOptionsOnMobile__23pFe","box":"box__30xLe","imageTag":"imageTag__3nBAH","imageTagBox":"imageTagBox__lSyyj"};